export const alerts = {
  START_FETCHING_ALERT_SUMMARY_DATA: 'START_FETCHING_ALERT_SUMMARY_DATA',
  SUCCESS_FETCHING_ALERT_SUMMARY_DATA: 'SUCCESS_FETCHING_ALERT_SUMMARY_DATA',
  FAILURE_FETCHING_ALERT_SUMMARY_DATA: 'FAILURE_FETCHING_ALERT_SUMMARY_DATA',
  CLEAR_ALERT_SUMMARY_DATA: 'CLEAR_ALERT_SUMMARY_DATA',
  START_FETCHING_ALERT_SUMMARY_DATA_PROPERTY: 'START_FETCHING_ALERT_SUMMARY_DATA_PROPERTY',
  SUCCESS_FETCHING_ALERT_SUMMARY_DATA_PROPERTY: 'SUCCESS_FETCHING_ALERT_SUMMARY_DATA_PROPERTY',
  FAILURE_FETCHING_ALERT_SUMMARY_DATA_PROPERTY: 'FAILURE_FETCHING_ALERT_SUMMARY_DATA_PROPERTY',
  CLEAR_ALERT_SUMMARY_DATA_PROPERTY: 'CLEAR_ALERT_SUMMARY_DATA_PROPERTY',
  START_FETCHING_ALERTS_CONFIG: 'START_FETCHING_ALERTS_CONFIG',
  SUCCESS_FETCHING_ALERTS_CONFIG: 'SUCCESS_FETCHING_ALERTS_CONFIG',
  FAILURE_FETCHING_ALERTS_CONFIG: 'FAILURE_FETCHING_ALERTS_CONFIG',
  CLEAR_ALERTS_CONFIG: 'CLEAR_ALERTS_CONFIG',
  START_UPDATE_ALERT: 'START_UPDATE_ALERT',
  SUCCESS_UPDATE_ALERT: 'SUCCESS_UPDATE_ALERT',
  FAILURE_UPDATE_ALERT: 'FAILURE_UPDATE_ALERT'
};
